import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  contactForm: FormGroup;

  faqs: any[] = [];

  constructor(private fb: FormBuilder) {
    this.contactForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      message: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.faqs = [
      {
        question: '¿Cuál es la política de devoluciones?',
        answer:
          'Puedes devolver cualquier producto dentro de los 30 días posteriores a la compra.',
        open: false,
      },
      {
        question: '¿Cómo puedo rastrear mi pedido?',
        answer:
          'Recibirás un correo electrónico con un enlace para rastrear tu pedido una vez que haya sido enviado.',
        open: false,
      },
      // ...puedes agregar más preguntas frecuentes aquí
    ];
  }

  toggleFaq(index: number) {
    this.faqs[index].open = !this.faqs[index].open;
  }

  onSubmit() {
    if (this.contactForm.valid) {
      const email = this.contactForm.get('email')?.value;
      const message = this.contactForm.get('message')?.value;
      const mailtoLink = `mailto:soporte@mymateapp.com?subject=Formulario%20de%20Contacto&body=Email:%20${email}%0AMensaje:%20${message}`;
      window.location.href = mailtoLink;
    }
  }
}
